import React, { useEffect } from 'react';
import '../css/TermsConditions.css';
import logo from '../images/logo.png';

const TermsConditions = () => {
  useEffect(() => {
        document.title = 'Terms and Conditions';

    // Scroll functionality
    const handleScrollTo = (position) => {
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    };

    // You can add event listeners here if needed
    // For now, we'll use inline onClick handlers
  }, []);

  return (
    <div className="terms-container">
      {/* Header */}
      <div className="terms-header">
        <div className="logo-terms">
          <img src={logo} alt="LSC Logo" />
        </div>
        <h6>OUR TERMS & PRIVACY POLICY</h6>
        <ul className="nav">
          <a href="/">
            <li><i className="fas fa-home"></i>&nbsp;Go to Homepage</li>
          </a>
        </ul>
      </div>

      {/* Main Content */}
      <main className="wrapper">
        <div className="terms">
          <div className="sidebar">
            <ul className="terms-sidebar-content">
              <li className="in-pl" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                Introduction
              </li>
              <li className="pr-pl" onClick={() => window.scrollTo({ top: 175, behavior: 'smooth' })}>
                Privacy policy
              </li>
              <li className="co-pl" onClick={() => window.scrollTo({ top: 755, behavior: 'smooth' })}>
                Cookie policy
              </li>
              <li className="da-pl" onClick={() => window.scrollTo({ top: 1445, behavior: 'smooth' })}>
                Data policy
              </li>
              <li className="ge-pl" onClick={() => window.scrollTo({ top: 1852, behavior: 'smooth' })}>
                General
              </li>
            </ul>
          </div>
          
          <div className="content-side">
            <h5>Introduction</h5>
            <p>
              The terms on using LSC LLMS website is an agreement with <b>LOGISTICS SECTOR SKILL COUNCIL, Chennai - 600 035.</b> which will be referred as the "Company" or "We", "Our", "Us" from now on. The LLMS website <a href="https://lsc-india.org/" target="_blank" rel="noopener noreferrer">lsc-india.org/</a> from now on will be referred as "Website". The user will be referred as "you", "your" depending on the context from now on. The user should read, understand and agree to the terms incorporated below before using our services.
            </p>
            
            <section className="privacy term-secs" id="privacy">
              <h5>Privacy Policy</h5>
              <hr />
              <h6>Information We Collect & How We Use It?</h6>
              <p>
                We collect information from you for us to know your identity and we use it to serve you according to your needs. We collect your personal information for us to identify you for the specific service you've chosen and that's the reason behind creating an account with us. We will collect your name, email, phone and other necessary information. We will not share or trade your personal information unless it's necessary for you to access any other third-party service or functionalities.
              </p>
              <h6>Information Disclosure</h6>
              <p>
                The information collected from you will not be disclosed to any other entity unless you agree to the terms and conditions put forth by us in order to use a specific service where we integrate with third-party service providers. If you don't want your data to be disclosed with third-party service providers, you will not be able to use certain features provided by us.
              </p>
              <h6>Tracking and Cookies</h6>
              <p>
                We will track your activities on the website to serve you better by saving sessions as cookies in your browser. We will be able to know when you login or logout of our website. More information regarding cookies are mentioned in Cookie Policy below.
              </p>
              <h6>Third-Party Embed</h6>
              <p>
                We integrate with a couple of third-party service providers to serve you better. We will share your data with them for you to use those applications seamlessly. Your account information including username, password, email, phone will be shared for the same purpose.
              </p>
            </section>
            
            <section className="cookie term-secs" id="cookie">
              <h5>Cookie Policy</h5>
              <hr />
              <h6>What are cookies?</h6>
              <p>
                Cookies are simple text files that are stored on your computer or mobile device by a website's server. Each cookie is unique to your web browser. It will contain some anonymous information such as a unique identifier, website's domain name, and some digits and numbers.
              </p>
              <h6>What types of cookies do we use?</h6>
              <h6>Necessary cookies:</h6>
              <p>
                Necessary cookies allow us to offer you the best possible experience when accessing and navigating through our website and using its features. For example, these cookies let us recognize that you have created an account and have logged into that account.
              </p>
              <h6>Functionality cookies:</h6>
              <p>
                Functionality cookies let us operate the site in accordance with the choices you make. For example, we will recognize your username and remember how you customized the site during future visits.
              </p>
              <h6>Analytical cookies:</h6>
              <p>
                These cookies enable us and third-party services to collect aggregated data for statistical purposes on how our visitors use the website. These cookies do not contain personal information such as names and email addresses and are used to help us improve your user experience of the website.
              </p>
              <h6>How to delete cookies?</h6>
              <p>
                If you want to restrict or block the cookies that are set by our website, you can do so through your browser setting. Alternatively, you can visit <a href="https://www.internetcookies.org/" target="_blank" rel="noopener noreferrer">www.internetcookies.org</a>, which contains comprehensive information on how to do this on a wide variety of browsers and devices. You will find general information about cookies and details on how to delete cookies from your device.
              </p>
            </section>
            
            <section className="data term-secs" id="data">
              <h5>Data Policy</h5>
              <hr />
              <h6>Data Usage</h6>
              <p>
                The information we have collected may be shared for marketing purpose to market our services to all our users. It will also be used to suggest you specific services according to certain criteria you have mentioned while registering with us.
              </p>
              <h6>Data Storage</h6>
              <p>
                The data we collect from you will be stored in a secured database on our server. Your data such as Name, Email, Phone will be accessible by us but we not use it by any means without your permission. Your password will be encrypted and we will not be able to access your password. We will not be able to log in to your account with your password.
              </p>
              <h6>Data Security</h6>
              <p>
                Your data is under our private domain on the cloud which we have secured with latest possible encryptions. We will be prudent in maintaining your data in our server environment or anywhere we use it for providing you service. Our cyber team will be working to protect your data against any cyber attacks.
              </p>
              <h6>Modifying or Deleting Your Personal Information</h6>
              <p>
                Your personal information we hold will never be modified or deleted without your permission/intent. We will never access your personal information owing to our own preferences.
              </p>
            </section>
            
            <section className="general term-secs" id="general">
              <h5>General</h5>
              <hr />
              <h6>Newsletter</h6>
              <p>
                If you opt for your newsletter service by entering your Email ID in the footer section, you will be added to our mailing list. We use MailChimp as our third-party service provider. We will share the information to them to send newsletters to you. You can opt out of this service anytime by clicking the unsubscribe link found at the bottom of any email sent to you from MailChimp.
              </p>
              <h6>Changes to this policy</h6>
              <p>
                We have the right to change our policies without prior information and it will reflect on our preferable date and time. We can change the terms on any of the above mentioned topic and force it to be implemented with immediate effect.
              </p>
              <h6>Contact us</h6>
              <p>
                If you have any queries regarding our policies, do mail us at <b>solutions@lsc-india.com</b>
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsConditions;